<template>
    <div class="headerBox">
        <div class="logoRowFrame">
            <div class="logoRow">
                <div class="loginBox">
                    <div class="divRow" v-if="this.$store.state.user">
                        <span>您好！</span>
                        <router-link to="/User">{{ this.$store.state.user.userPhone }}</router-link>
                        <div class="quit" @click="quitAccount">退出</div>
                    </div>
                    <div class="divRow" v-else>
                        <span>您好！</span>
                        <div @click="switchAfterClear(1)">请登录</div>
                    </div>
                </div>
                <div class="operationBox">
                    <router-link to="/" class="item_operation">
                        <img src="../assets/images/home.png" alt="首页">
                        <span>首页</span>
                    </router-link>
                    <div class="item_operation" v-show="!this.$store.state.user" @click="switchAfterClear(0)">
                        <img src="../assets/images/register.png" alt="注册">
                        <span>注册</span>
                    </div>
                    <div class="item_operation" @click="monitorIslogin(1)">
                        <img src="../assets/images/myseccions.png" alt="我的订单">
                        <span>我的订单</span>
                    </div>
                    <div class="item_operation hide" @click="monitorIslogin(2)">
                        <img src="../assets/images/mynews.png" alt="我的消息">
                        <span>我的消息</span>
                    </div>
                    <div class="item_operation" @click="monitorIslogin(3)">
                        <img src="../assets/images/cart.png" alt="购物车">
                        <span>我的购物车</span>
                        <span class="red" v-show="false">({{ cartCount }})</span>
                    </div>
                    <div class="item_operation" @click="monitorIslogin(4)">
                        <img src="../assets/images/user.png" alt="个人中心">
                        <span>个人中心</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="searchRow">
            <router-link to="/" class="logoBox">
                <img :src="logImg" alt="logo">
            </router-link>
            <div class="searchBox">
                <input type="text" placeholder="请输入您想要的测试服务关键词" v-model="searchStr">
                <div class="searchButton" @click="toSearch">
                    <img src="../assets/images/search.png" alt="搜索">
                    <span>搜索</span>
                </div>
            </div>
            <div class="telFrame">
                <img src="../assets/images/tel.png" alt="热线电话">
                <div class="telBox">
                    <span class="telText">热线电话</span>
                    <span class="tel">{{ this.getFirstPhone(phone) }}</span>
                </div>
            </div>
        </div>
        <div class="nav" :class="{isIndex:this.$store.state.isShowIndex}">
            <router-link to="/"
                         :class="{active:this.$store.state.navIndex==1}"
                         class="item_nav">首页
            </router-link>
            <div class="item_nav"
                 :class="{active:this.$store.state.navIndex==2}"
                 @click="nav_click(1)"
                 @mouseover="nav_mouseover(1)">我们的服务
            </div>
            <div class="item_nav"
                 :class="{active:this.$store.state.navIndex==6}"
                 @click="nav_click(2)"
                 @mouseover="nav_mouseover(2)">解决方案
            </div>
            <router-link
                :class="{active:this.$store.state.navIndex==3}"
                to="/ProductList" class="item_nav">在线下单
            </router-link>
            <router-link
                :class="{active:this.$store.state.navIndex==4}"
                to="/Resource" class="item_nav">资源中心
            </router-link>
            <router-link
                :class="{active:this.$store.state.navIndex==7}"
                to="/TestStandard" class="item_nav">检测标准
            </router-link>
            <router-link
                :class="{active:this.$store.state.navIndex==5}"
                to="/About" class="item_nav">关于中安
            </router-link>
            <div class="nav_category_background"
                 v-show="$store.state.isShowCategory"
                 @mouseleave="leaveBlock1">
                <div class="nav_category nav_category1">
                    <div class="item_cate item_cate1"
                         :class="{'on':item.isSelected}"
                         @click="switchToList(item.id)"
                         @mouseover="hoverCate(1,index)"
                         v-for="(item,index) in array1"
                         :key="index">{{ item.serivceTypeName }}
                    </div>
                </div>
                <div
                    v-show="show2"
                    class="block2">
                    <div
                        class="nav_category nav_category2">
                        <div class="item_cate item_cate2"
                             :class="{'on':item2.isSelected}"
                             @click="switchToList(item2.id)"
                             @mouseover="hoverCate(2,index)"
                             v-for="(item2,index) in array2"
                             :key="index">
                            {{ item2.serivceTypeName }}
                        </div>
                    </div>
                    <div
                        class="nav_category nav_category3">
                        <div class="item_cate item_cate3"
                             :class="{'on':item3.isSelected}"
                             @click="switchToList(item3.id)"
                             v-for="(item3,index) in array3"
                             :key="index">{{ item3.serivceTypeName }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Store from "../store";

export default {
    name: 'headerComponents',
    data() {
        return {
            advertList: [
                {
                    imgPath: 'http://www.labbase.net/upload/202012/11/202012111540365968.jpg'
                },
                {
                    imgPath: 'http://www.labbase.net/upload/202105/28/202105281554024767.jpg'
                },
                {
                    imgPath: 'http://img1.alaibao.cn/pimages/Product/800800/202012/2c82b323fb9c426abf8efa984c475233.jpg'
                }
            ],
            category_serve: [],
            category_solution: [],

            array1: [],
            array2: [],
            array3: [],
            show2: false,
            cartCount: 0,
            searchStr: '',
            logImg: "",
            phone: "",
        }
    },
    watch: {
        '$store.state.searchStr'() {
            this.searchStr = this.$store.state.searchStr
        },
    },
    mounted() {
        this.searchStr = this.$store.state.searchStr
        this.getServeTypeList()
        this.getSolutionTypeList()
        this.getWebInfo()
        // this.getCartCount()
    },
    methods: {
        /**
         * 悬浮目录监听
         **/
        hoverCate(level, index) {
            let param;
            if (level == 1) {
                this.show2 = true
                param = this.array1[index].children
                // console.log('1', param)
                this.array2 = param
                //调整一级目录选中
                for (let j = 0; j < this.array1.length; j++) {
                    if (this.array1[j].isSelected && j != index) {
                        this.array1[j].isSelected = false
                    }
                }
                this.array1[index].isSelected = true

                //调整二级目录选中
                if (!this.$isNullOrUndefined(param)) {
                    //二级目录是否有选中的
                    let isSelected = false;
                    for (let i = 0; i < this.array2.length; i++) {
                        if (this.array2[i].isSelected) {
                            isSelected = true
                            //赋值给三级目录
                            this.array3 = this.array2[i].children
                        }
                    }
                    if (!isSelected) {
                        this.hoverCate(2, 0)
                    }
                } else {
                    //二级目录空，则重置三级目录
                    this.array3 = [];
                }
            } else {
                // console.log(this.array2)
                param = this.array2[index].children
                // console.log('2', param)
                this.array3 = param
                //调整二级目录选中
                for (let i = 0; i < this.array2.length; i++) {
                    if (this.array2[i].isSelected && i != index) {
                        this.array2[i].isSelected = false
                    }
                }
                this.array2[index].isSelected = true
            }
            this.$forceUpdate()
        },

        /**
         * 离开目录
         **/
        leaveBlock1() {
            this.show2 = false;
            this.array3 = [];
            for (let i = 0; i < this.array1.length; i++) {
                if (this.array1[i].isSelected) {
                    this.array1[i].isSelected = false
                }
            }
            //如果不在首页，离开需要隐藏目录
            if (!this.$store.state.isShowIndex) {
                this.$store.commit('setFloatCategory', false)
            }
            this.$forceUpdate()
        },

        /**
         * 悬浮目录 1服务 2方案
         * 若首页，通过悬浮，控制目录显示、隐藏
         **/
        nav_mouseover(type) {
            //首页悬浮显示
            if (this.$store.state.isShowIndex) {
                switch (type) {
                    case 1:
                        if (!this.$store.state.isShowServe) {
                            this.array1 = this.category_serve
                            this.$store.commit('isShow_serve', true)
                        }
                        break;
                    case 2:
                        if (this.$store.state.isShowServe) {
                            this.array1 = this.category_solution
                            this.$store.commit('isShow_serve', false)
                        }
                        break;
                }
            }
        },

        /**
         * 点击导航栏切换 1服务 2方案
         * 若非首页，通过点击，控制目录显示、隐藏
         **/
        nav_click(type) {
            if (!this.$store.state.isShowIndex) {
                switch (type) {
                    case 1:
                        if (!this.$store.state.isShowCategory) {
                            //当前未显示目录
                            if (!this.$store.state.isShowServe) {
                                //若数据为方案，则改为服务，展示
                                this.array1 = this.category_serve
                                this.$store.commit('isShow_serve', true)
                            }
                            this.$store.commit('setFloatCategory', true)
                        } else {
                            //当前显示目录
                            if (this.$store.state.isShowServe) {
                                //关闭
                                this.$store.commit('setFloatCategory', false)
                            } else {
                                //若数据为方案，则改为服务，展示
                                this.array1 = this.category_serve
                                this.$store.commit('isShow_serve', true)
                            }
                        }
                        break;
                    case 2:
                        if (!this.$store.state.isShowCategory) {
                            //当前未显示目录
                            if (this.$store.state.isShowServe) {
                                //若数据为方案，则改为服务，展示
                                this.array1 = this.category_solution
                                this.$store.commit('isShow_serve', false)
                            }
                            this.$store.commit('setFloatCategory', true)
                        } else {
                            //当前显示目录
                            if (!this.$store.state.isShowServe) {
                                //关闭
                                this.$store.commit('setFloatCategory', false)
                            } else {
                                //若数据为服务，则改为方案，展示
                                this.array1 = this.category_solution
                                this.$store.commit('isShow_serve', false)
                            }
                        }
                        break;
                }
            }
        },

        /**
         * 跳转到列表页
         * stid 类别id
         **/
        switchToList(stid) {
            if (this.$store.state.isShowServe) {
                //数据为服务
                this.$router.push({name:'ServeList',params:{stId:stid}});
            } else {
                //数据为方案
                this.$router.push({name:'SolutionList',params:{stId:stid}});
            }
            this.$routerPushMustGo()
        },

        /**
         * 获取服务列表
         */
        getServeTypeList() {
            this.$get('/V1/ServiceType/GetAllServiceTypes', {})
                .then((res) => {
                    // console.log('serve', res)
                    if (res.success) {
                        let tmp = res.response;
                        this.category_serve = tmp
                        this.array1 = tmp
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 获取方案列表
         */
        getSolutionTypeList() {
            this.$get('/V1/SolutionType/GetAllServiceTypes', {})
                .then((res) => {
                    // console.log('solution', res)
                    if (res.success) {
                        this.category_solution = res.response
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 监听是否登录
         */
        monitorIslogin(index) {
            if (!this.$noLoginAndRouter())
                switch (index) {
                    case 1:
                        this.clearNavClas()
                        this.$store.commit('setIndex', false)
                        this.$router.push('/User/Order')
                        break
                    case 2:
                        break
                    case 3:
                        this.clearNavClas()
                        this.$router.push('/Cart')
                        break
                    case 4:
                        this.clearNavClas()
                        this.$router.push('/User')
                        break
                }
        },

        /**
         * 跳转搜索
         */
        toSearch() {
            if (this.$isNullOrUndefined((this.searchStr))) {
                this.$message.warning("请输入搜索词!")
            } else {
                this.$store.commit('setSearchStr', this.searchStr)
                this.$router.push({name: 'Search', params: {str: this.searchStr}})
                this.clearNavClas()
            }
        },

        /**
         * 获取网站信息
         */
        getWebInfo() {
            this.$get('/V1/WebInfo/GetWebInfoDetail', {})
                .then((res) => {
                    // console.log('web', res)
                    if (res.success) {
                        this.logImg = res.response.logImg
                        this.phone = res.response.phone
                        this.$store.commit('setLoginOrRegisterBackImg', res.response.loginImg)
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 清除导航选中样式
         */
        clearNavClas() {
            this.$store.commit('setNav', 0)
        },

        /**
         * 去注册或注册
         */
        switchAfterClear(index) {
            this.clearNavClas()
            switch (index) {
                case 0:
                    this.$router.push('/Register')
                    break;
                case 1:
                    this.$router.push('/Login')
                    break
            }
        },

        /**
         * 退出账号
         */
        quitAccount() {
            this.$confirm('确定退出当前账号?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning '
            }).then(() => {
                this.$message.success('已退出当前账号！')
                Store.commit('setIndex', false)
                this.$store.commit('clearUser')
                this.$router.push({name: 'Empty', params: {url: location.pathname}})
            }).catch(() => {
                //
            })
        },

        /**
         * 获取第一个联系方式
         * @param str 热线字符串
         * @returns {*}
         */
        getFirstPhone(str) {
            let tmp = str.split(' ')
            // console.log('phone',tmp)
            return tmp[0]
        },
    }
}

</script>

<style scoped lang="less">
.headerBox {
    display: flex;
    flex-direction: column;
    z-index: 999;
    background-color: white;

    .logoRowFrame {
        width: 100%;
        background-color: #e6e6e6;
        box-shadow: 0px 2px 5px 0px #eeeeee;
        height: 44px;

        .logoRow {
            width: 1210px;
            height: 44px;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .loginBox {
                display: flex;
                flex-direction: row;
                align-items: center;

                .divRow {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    .quit {
                        margin-left: 20px;
                        font-size: 12px;
                        color: #999;
                    }

                    div {
                        cursor: pointer;
                    }
                }

                * {
                    font-size: 14px;
                    color: #474747;
                }
            }

            .operationBox {
                display: flex;
                flex-direction: row;
                align-items: center;

                .item_operation {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin: 0px 20px;
                    cursor: pointer;

                    img {
                        margin: 0px 4px;
                    }

                    span {
                        font-size: 14px;
                        color: #474747;
                    }

                    .red {
                        color: #f10000;
                    }
                }
            }
        }
    }

    .searchRow {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 100px;
        width: 1210px;
        margin: 0 auto;

        .logoBox {
            height: 80px;
            width: 250px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .searchBox {
            display: flex;
            flex-direction: row;
            align-items: center;

            input {
                height: 40px;
                width: 480px;
                border: 1px solid #1f2d5c;
                border-right: none;
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
                padding: 0px 20px;
                line-height: 40px;
                font-size: 15px;
            }

            input::placeholder {
                color: #adadad;
                letter-spacing: .5px;
            }

            .searchButton {
                background-color: #1f2d5c;
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;
                border: 1px solid #1f2d5c;
                height: 40px;
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 0px 10px;
                cursor: pointer;

                img {
                    width: 14px;
                    height: 14px;
                    margin-right: 5px;
                }

                span {
                    color: white;
                    font-size: 14px;
                    line-height: 14px;
                }
            }
        }

        .telFrame {
            display: flex;
            flex-direction: row;
            align-items: center;

            img {
            }

            .telBox {
                display: flex;
                flex-direction: column;
                margin-left: 5px;

                .telText {
                    color: #666666;
                    font-size: 16px;
                }

                .tel {
                    color: #1f2d5c;
                    font-size: 20px;
                    font-weight: bold;
                    white-space: nowrap;
                    overflow: hidden;
                }
            }
        }

    }

    .isIndex {

        .item_nav:nth-child(1) {
            display: none;
        }

        .item_nav {
            width: 200px;
        }
    }

    .nav {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        margin: 0 auto;
        position: relative;

        .item_nav {
            font-size: 16px;
            font-weight: bold;
            color: #7b7978;
            width: 200px;
            line-height: 44px;
            text-align: center;
            cursor: pointer;
        }

        .active, .item_nav:hover {
            color: white;
            background-color: #1f2d5c;
            transition: .4s;
        }
    }

    .nav_serve {
        width: 400px !important;
    }

    .nav_solution {
        width: 600px !important;
    }

    .serve_shadow {
        background-color: rgba(0, 0, 0, 0.03) !important;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.05);
    }

    .solution_shadow {
        background-color: rgba(0, 0, 0, 0.03) !important;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.05);
    }

    .hideMore {
        width: 240px;
    }

    .nav_category_background {
        height: 480px;
        background-color: transparent;
        position: absolute;
        top: 44px;
        left: 0;
        z-index: 999;
        display: flex;
        flex-direction: row;

        .nav_category {
            display: flex;
            overflow-y: auto;
        }

        .item_cate {
            height: 40px;
            line-height: 40px;
            cursor: pointer;
        }

        .item_cate:hover {

        }

        .nav_category1 {
            background-color: #1f2d5c;
            border: 1px solid #1f2d5c;
            flex-direction: column;
            width: 240px;
            height: 480px;
            position: relative;

            .item_cate1 {
                color: white;
                padding-left: 40px;
            }

            .item_cate1:hover, .on {
                background-color: white;
                color: #1f2d5c;
            }
        }

        .nav_category2 {
            flex-direction: column;
            background-color: #f5f5f5;
            border-right: 1px solid #999;
            width: 240px;
            height: 480px;

            .item_cate2 {
                color: #1f2d5c;
                padding-left: 40px;
            }

            .item_cate2:hover, .on {
                background-color: white;
            }
        }

        .nav_category3 {
            background-color: #f5f5f5;
            border-top: none;
            border-bottom: none;
            width: 680px;
            height: 440px;
            flex-direction: row;
            flex-wrap: wrap;
            align-content: flex-start;
            padding: 20px;
            z-index: 1;

            .item_cate3 {
                color: #1f2d5c;
                margin: 0 10px;

            }

            .item_cate3:hover, .on {
                color: #fbbb06
            }
        }

        .block2 {
            display: flex;
            flex-direction: row;
            width: 958px;
            height: 478px;
            border: 1px solid #1f2d5c;
        }
    }
}
</style>

